import React, { FunctionComponent } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

import Query from 'scenes/Report/components/Query';
import { ReportParams } from 'scenes/Report/components/ReportBase';
import {
  MetricsByMetro,
  TopMetrosByAov,
} from 'components/TopMetros/TopMetros.helpers';
import GET_METRICS_BY_METRO from 'components/TopMetros/TopMetros.queries';

import TopMetro from '../components/TopMetro';

type QueryResponse = {
  metricsByMetro: {
    transactionMetricsByMetro: MetricsByMetro[];
    topMetrosByAov: TopMetrosByAov[];
  };
};

const renderReport = (params: ReportParams) => ({
  metricsByMetro: { transactionMetricsByMetro, topMetrosByAov },
}: QueryResponse) => (
  <TopMetro
    data={transactionMetricsByMetro}
    topMetros={topMetrosByAov}
    params={params}
    type="AOV"
  />
);

const TopMetroAov: FunctionComponent = () => {
  const location = useLocation();
  const params = queryString.parse(location.search) as ReportParams;

  return (
    <Query
      query={GET_METRICS_BY_METRO}
      reportName="Top Metro AOV"
      batchKey="topMetroAOV"
      queryKey="metricsByMetro"
      variables={{ params }}
      render={renderReport(params)}
    />
  );
};

export default TopMetroAov;
